import React, { useEffect, useState } from "react";
import { InputAuto, Select } from "../../../controls";
import { action, API, controller } from "../../../api/api";
import { DropLi } from "../../../hooks";

const Filter = ({ setSearchTerm, searchTerm }) => {
  const { SalesType } = DropLi();
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    API(controller.Customer + action.GetAllByOrg).get((res) => {
      if (res && res.status === 200) {
        setCustomers([
          ...res.result.map((j) => ({
            id: j.id,
            label: `${j.firstName} ${j.lastName}`,
            subtitle: [j.phone, j.cstmrGroup?.name].filter(Boolean).join(" | "),
          })),
        ]);
      }
    });
    return () => {};
  }, []);

  const handleInpChg = (e) => {
    setSearchTerm({ ...searchTerm, [e.target.name]: e.target.value });
  };

  return (
    <div className="flex gap-2 w-full lg:min-w-[450px]">
      <Select
        variant="outlined"
        size="small"
        fullWidth
        name="saleType"
        value={searchTerm.saleType}
        onChange={handleInpChg}
        options={SalesType}
      />
      <InputAuto
        placeholder="Search for customers"
        variant="outlined"
        size="small"
        fullWidth
        name="customerId"
        value={searchTerm.customerId}
        onChange={handleInpChg}
        options={customers}
      />
    </div>
  );
};

export default Filter;
